import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import PollFragment from "@irati/recognition/apollo/fragments/Poll"
import partialUser from "@irati/identity/services/fragments/PartialUser"

const query = gql`
  query getCelebrationsReport(
    $businessId: ID!
    $regionIds: [ID!]
    $teamIds: [ID!]
    $duration: CelebrationsReportDuration
    $category: CelebrationsReportCategory
    $month: DateInput
    $limit: Int
  ) {
    celebrationsReport(
      businessId: $businessId
      regionIds: $regionIds
      teamIds: $teamIds
      duration: $duration
      category: $category
      month: $month
      limit: $limit
    ) {
      availableDates {
        month
        year
      }
      recognition {
        users {
          uuid
          recognitionIds
          recognitions {
            recognitionId
            rpTransferred
          }
          companyValues {
            name
            count
            icon {
              href
              alt
            }
          }
          user {
            firstName
            lastName
            teams {
              results {
                public_name
              }
            }
          }
          regionName
        }
        teams {
          recognitionIds
          recognitions {
            recognitionId
            rpTransferred
          }
          companyValues {
            name
            count
            icon {
              href
              alt
            }
          }
          team {
            teamName
            users {
              total
              results {
                ...partialUser
              }
            }
          }
        }
      }
      companyValuesAndCelebrations {
        companyValues {
          valueId
          usageCount
          name
          icon {
            href
            alt
          }
        }
        celebrations {
          celebrationId
          usageCount
          name
          icon {
            href
            alt
          }
        }
      }
      polls {
        winners {
          user {
            firstName
            lastName
            profileImageUrl
            teams {
              results {
                public_name
              }
            }
          }
          regionName
          totalVotesReceived
          pollIds
        }
        polls {
          pollId
          poll {
            ...Poll
          }
          title
          criteria
          totalVotes
          totalNominees
          companyValueIds
          companyValues {
            results {
              uuid
              name
              icon {
                href
                alt
              }
            }
          }
          createdAt {
            seconds
          }
          voteEndedAt {
            seconds
          }
        }
      }
    }
  }
  ${partialUser}
  ${PollFragment}
`

export const celebrationsReportKey = getQueryNames(query)[0]

export default query
